import PlatformService from '@/services/platform.service'
import FetchService from '@/services/fetch.service'

export default defineNuxtPlugin({
  async setup(_nuxtApp) {
    const headers = useRequestHeaders()
    const $pinia = usePinia()

    const platformService = new PlatformService(headers)
    const fetchService = new FetchService($pinia, {
      osName: platformService.osName,
    })

    return {
      provide: {
        platformService,
        fetchService,
      },
    }
  },
})
